import { SpaceBetween, TextContent } from "@amzn/awsui-components-react"
import partners from "api/partners"
import Breadcrumbs from "pmsa-polaris/components/Breadcrumbs"
import MainLayout from "pmsa-polaris/components/MainLayout"
import usePromise from "pmsa-polaris/hooks/usePromise"
import { useEffect } from "react"
import { useParams } from "react-router-dom"

import GTMList from "./GTMList"
import ToolsPanel from "./tool-topics"

const GTM = () => {
  const { id: idParam, dimension: dimensionParam } = useParams()

  const id = idParam!
  const dimension = dimensionParam!

  const [{ data: partner }, getPartner] = usePromise(partners.get)
  const [{ loading, error, data: gtms }, getGtm] = usePromise(partners.getGTM)

  useEffect(() => {
    getGtm(id, dimension)
    getPartner(id)
  }, [getGtm, id])

  return (
    <MainLayout
      breadcrumbs={
        <Breadcrumbs
          items={[
            { text: "Partners", href: "/" },
            {
              text: partner ? partner.partnerName : id,
              href: `/partners/${id}`,
            },
            { text: dimension, href: "" },
            { text: "GTM", href: "" },
          ]}
        />
      }
      tools={<ToolsPanel />}
    >
      <SpaceBetween size="l">
        <TextContent>
          <h1>GTM</h1>
        </TextContent>
        <GTMList
          dimension={dimension}
          error={error}
          data={gtms!}
          loading={loading}
        />
        {/* <DimensionsContainer id={id} partner={partner} /> */}
      </SpaceBetween>
    </MainLayout>
  )
}

export default GTM
